//----------------------Sunset Fest Resized -------------------------
import image1 from '../../assets/resized/sunset fest/ISP_6809JPG.jpg';
import image2 from '../../assets/resized/sunset fest/ISP_6830JPG.jpg';
import image3 from '../../assets/resized/sunset fest/ISP_6831JPG.jpg';
import image4 from '../../assets/resized/sunset fest/ISP_6832JPG.jpg';
import image5 from '../../assets/resized/sunset fest/ISP_6833JPG.jpg';
import image6 from '../../assets/resized/sunset fest/ISP_6834JPG.jpg';
// import image7 from '../../assets/ISP_6835.JPG';
import image8 from '../../assets/resized/sunset fest/ISP_6843JPG.jpg';
import image9 from '../../assets/resized/sunset fest/ISP_6846JPG.jpg';
import image10 from '../../assets/resized/sunset fest/ISP_6847JPG.jpg';
import image11 from '../../assets/resized/sunset fest/ISP_6848JPG.jpg';
import image12 from '../../assets/resized/sunset fest/ISP_6849JPG.jpg';
// import image13 from '../../assets/ISP_6853.JPG';
import image14 from '../../assets/resized/sunset fest/ISP_6864JPG.jpg';
import image15 from '../../assets/resized/sunset fest/ISP_6865JPG.jpg';
import image16 from '../../assets/resized/sunset fest/ISP_6866JPG.jpg';
import image17 from '../../assets/resized/sunset fest/ISP_6867JPG.jpg';
import image18 from '../../assets/resized/sunset fest/ISP_6876JPG.jpg';
import image19 from '../../assets/resized/sunset fest/ISP_6878JPG.jpg';
import image20 from '../../assets/resized/sunset fest/ISP_6915JPG.jpg';
import image21 from '../../assets/resized/sunset fest/ISP_6927JPG.jpg';
import image22 from '../../assets/resized/sunset fest/ISP_6932JPG.jpg';
import image23 from '../../assets/resized/sunset fest/ISP_6933JPG.jpg';
import image24 from '../../assets/resized/sunset fest/ISP_6934JPG.jpg';
import image25 from '../../assets/resized/sunset fest/ISP_6935JPG.jpg';
import image26 from '../../assets/resized/sunset fest/ISP_6945JPG.jpg';
import image27 from '../../assets/resized/sunset fest/ISP_6947JPG.jpg';
import image28 from '../../assets/resized/sunset fest/ISP_6950JPG.jpg';
import image29 from '../../assets/resized/sunset fest/ISP_6953JPG.jpg';
import image30 from '../../assets/resized/sunset fest/ISP_6965JPG.jpg';
//--------------------------------------------------------------------

//----------------------Safari Resized -------------------------------
import safariImage2 from '../../assets/resized/safari/DFI_6395.jpg';
import safariImage4 from '../../assets/resized/safari/ISP_3887JPG.jpg';
import safariImage6 from '../../assets/resized/safari/ISP_3888JPG.jpg';
import safariImage8 from '../../assets/resized/safari/ISP_3889JPG.jpg';
import safariImage9 from '../../assets/resized/safari/ISP_3896JPG.jpg';
import safariImage10 from '../../assets/resized/safari/ISP_3903JPG.jpg';
import safariImage11 from '../../assets/resized/safari/ISP_3906JPG.jpg';
import safariImage12 from '../../assets/resized/safari/ISP_3909JPG.jpg';
import safariImage13 from '../../assets/resized/safari/ISP_3911JPG.jpg';
import safariImage14 from '../../assets/resized/safari/ISP_3937JPG.jpg';
import safariImage15 from '../../assets/resized/safari/ISP_7158JPG.jpg';
import safariImage16 from '../../assets/resized/safari/ISP_7180JPG.jpg';
import safariImage17 from '../../assets/resized/safari/ISP_7182JPG.jpg';
import safariImage18 from '../../assets/resized/safari/ISP_7197JPG.jpg';
import safariImage19 from '../../assets/resized/safari/ISP_7201JPG.jpg';
import safariImage20 from '../../assets/resized/safari/ISP_7213JPG.jpg';
import safariImage21 from '../../assets/resized/safari/ISP_7237JPG.jpg';
import safariImage22 from '../../assets/resized/safari/ISP_7244JPG.jpg';
import safariImage23 from '../../assets/resized/safari/ISP_7252JPG.jpg';
import safariImage24 from '../../assets/resized/safari/ISP_7274JPG.jpg';
//-----------------------------------------------------------------------

//----------------------Wild Fest Resized -------------------------------
import wildFestImage1 from '../../assets/resized/wild fest/ISP_6502JPG.jpg';
import wildFestImage2 from '../../assets/resized/wild fest/ISP_6503JPG.jpg';
import wildFestImage3 from '../../assets/resized/wild fest/ISP_6504JPG.jpg';
import wildFestImage4 from '../../assets/resized/wild fest/ISP_6506JPG.jpg';
import wildFestImage5 from '../../assets/resized/wild fest/ISP_6507JPG.jpg';
import wildFestImage6 from '../../assets/resized/wild fest/ISP_6513JPG.jpg';
import wildFestImage7 from '../../assets/resized/wild fest/ISP_6518JPG.jpg';
import wildFestImage8 from '../../assets/resized/wild fest/ISP_6520JPG.jpg';
// import wildFestImage9 from '../../assets/resized/wild fest/ISP_6523JPG.jpg';
import wildFestImage10 from '../../assets/resized/wild fest/ISP_6527JPG.jpg';
import wildFestImage11 from '../../assets/resized/wild fest/ISP_6528JPG.jpg';
import wildFestImage12 from '../../assets/resized/wild fest/ISP_6529JPG.jpg';
import wildFestImage13 from '../../assets/resized/wild fest/ISP_6530JPG.jpg';
import wildFestImage14 from '../../assets/resized/wild fest/ISP_6531JPG.jpg';
import wildFestImage15 from '../../assets/resized/wild fest/ISP_6532JPG.jpg';
// import wildFestImage16 from '../../assets/resized/wild fest/ISP_6533JPG.jpg';
import wildFestImage17 from '../../assets/resized/wild fest/ISP_6539JPG.jpg';
import wildFestImage18 from '../../assets/resized/wild fest/ISP_6540JPG.jpg';
import wildFestImage19 from '../../assets/resized/wild fest/ISP_6541JPG.jpg';
import wildFestImage20 from '../../assets/resized/wild fest/ISP_6542JPG.jpg';
import wildFestImage21 from '../../assets/resized/wild fest/ISP_6543JPG.jpg';
import wildFestImage22 from '../../assets/resized/wild fest/ISP_6544JPG.jpg';
import wildFestImage23 from '../../assets/resized/wild fest/ISP_6545JPG.jpg';
import wildFestImage24 from '../../assets/resized/wild fest/ISP_6576JPG.jpg';
import wildFestImage25 from '../../assets/resized/wild fest/ISP_6577JPG.jpg';
import wildFestImage26 from '../../assets/resized/wild fest/ISP_6578JPG.jpg';
import wildFestImage27 from '../../assets/resized/wild fest/ISP_6583JPG.jpg';
import wildFestImage28 from '../../assets/resized/wild fest/ISP_6585JPG.jpg';
import wildFestImage29 from '../../assets/resized/wild fest/ISP_6586JPG.jpg';
import wildFestImage30 from '../../assets/resized/wild fest/ISP_6596JPG.jpg';
import wildFestImage31 from '../../assets/resized/wild fest/ISP_6598JPG.jpg';
import wildFestImage32 from '../../assets/resized/wild fest/ISP_6599JPG.jpg';
import wildFestImage33 from '../../assets/resized/wild fest/ISP_6600JPG.jpg';
import wildFestImage34 from '../../assets/resized/wild fest/ISP_6601JPG.jpg';
import wildFestImage35 from '../../assets/resized/wild fest/ISP_6602JPG.jpg';
import wildFestImage36 from '../../assets/resized/wild fest/ISP_6603JPG.jpg';
import wildFestImage37 from '../../assets/resized/wild fest/ISP_6605JPG.jpg';
import wildFestImage38 from '../../assets/resized/wild fest/ISP_6621JPG.jpg';
import wildFestImage39 from '../../assets/resized/wild fest/ISP_6622JPG.jpg';
import wildFestImage40 from '../../assets/resized/wild fest/ISP_6623JPG.jpg';
import wildFestImage41 from '../../assets/resized/wild fest/ISP_6624JPG.jpg';
import wildFestImage42 from '../../assets/resized/wild fest/ISP_6625JPG.jpg';

//---------------------- Promo Resized -------------------------------
import promoImage1 from '../../assets/resized/promo/ISP_4240.jpg';
import promoImage2 from '../../assets/resized/promo/ISP_4245.jpg';
import promoImage3 from '../../assets/resized/promo/ISP_4249.jpg';
import promoImage4 from '../../assets/resized/promo/ISP_4255.jpg';
import promoImage5 from '../../assets/resized/promo/ISP_4259-2.jpg';
import promoImage6 from '../../assets/resized/promo/ISP_4272.jpg';
import promoImage7 from '../../assets/resized/promo/ISP_4277.jpg';
import promoImage8 from '../../assets/resized/promo/ISP_4283.jpg';
import promoImage9 from '../../assets/resized/promo/ISP_4295.jpg';
import promoImage10 from '../../assets/resized/promo/ISP_4290.jpg';
import promoImage11 from '../../assets/resized/promo/ISP_5658JPG.jpg';
import promoImage12 from '../../assets/resized/promo/ISP_5661JPG.jpg';
import promoImage13 from '../../assets/resized/promo/ISP_5664JPG.jpg';
import promoImage14 from '../../assets/resized/promo/ISP_5665JPG.jpg';
import promoImage15 from '../../assets/resized/promo/ISP_5668JPG.jpg';
import promoImage16 from '../../assets/resized/promo/ISP_5669JPG.jpg';
import promoImage17 from '../../assets/resized/promo/ISP_5670JPG.jpg';
import promoImage18 from '../../assets/resized/promo/ISP_5671JPG.jpg';
import promoImage19 from '../../assets/resized/promo/ISP_5673JPG.jpg';
import promoImage20 from '../../assets/resized/promo/ISP_5674JPG.jpg';
import promoImage21 from '../../assets/resized/promo/ISP_5676JPG.jpg';
import promoImage22 from '../../assets/resized/promo/ISP_5678JPG.jpg';
import promoImage23 from '../../assets/resized/promo/ISP_5683JPG.jpg';
import promoImage24 from '../../assets/resized/promo/ISP_5690JPG.jpg';
import promoImage25 from '../../assets/resized/promo/ISP_9316.jpg';
import promoImage26 from '../../assets/resized/promo/ISP_9317.jpg';
import promoImage27 from '../../assets/resized/promo/ISP_9320.jpg';
import promoImage28 from '../../assets/resized/promo/ISP_9322.jpg';
import promoImage29 from '../../assets/resized/promo/ISP_9323.jpg';
import promoImage30 from '../../assets/resized/promo/ISP_9345.jpg';
import promoImage31 from '../../assets/resized/promo/ISP_9347.jpg';
import promoImage32 from '../../assets/resized/promo/ISP_9348.jpg';
import promoImage33 from '../../assets/resized/promo/ISP_9357.jpg';
import promoImage34 from '../../assets/resized/promo/ISP_9360.jpg';
import promoImage35 from '../../assets/resized/promo/ISP_9366.jpg';
import promoImage36 from '../../assets/resized/promo/ISP_9370.jpg';

// Nove Dekijeve slike 09.04.2025
import promoImage37 from '../../assets/resized/promo/Deki Anime.jpg';
import promoImage38 from '../../assets/resized/promo/ISP_3286.jpg';
import promoImage39 from '../../assets/resized/promo/ISP_3288.jpg';
import promoImage40 from '../../assets/resized/promo/ISP_3290.jpg';
import promoImage41 from '../../assets/resized/promo/ISP_3291.jpg';
import promoImage42 from '../../assets/resized/promo/ISP_3293.jpg';
import promoImage43 from '../../assets/resized/promo/ISP_3300 3.jpg';
import promoImage44 from '../../assets/resized/promo/ISP_3310.jpg';
import promoImage45 from '../../assets/resized/promo/ISP_3312.jpg';
import promoImage46 from '../../assets/resized/promo/ISP_3319.jpg';
import promoImage47 from '../../assets/resized/promo/ISP_3324.jpg';
import promoImage48 from '../../assets/resized/promo/ISP_3326.jpg';
import promoImage49 from '../../assets/resized/promo/ISP_3335.jpg';
import promoImage50 from '../../assets/resized/promo/ISP_3337.jpg';
import promoImage51 from '../../assets/resized/promo/ISP_3339.jpg';
import promoImage52 from '../../assets/resized/promo/ISP_3340.jpg';
import promoImage53 from '../../assets/resized/promo/ISP_3341.jpg';
import promoImage54 from '../../assets/resized/promo/ISP_3357.jpg';
import promoImage55 from '../../assets/resized/promo/ISP_3363.jpg';
import promoImage56 from '../../assets/resized/promo/ISP_3365.jpg';
import promoImage57 from '../../assets/resized/promo/ISP_3370.jpg';
import promoImage58 from '../../assets/resized/promo/ISP_3374.jpg';
import promoImage59 from '../../assets/resized/promo/ISP_3375.jpg';

// Nove slike 16.04.2026
import promoImage60 from '../../assets/resized/promo/ISP_0638.jpg';
import promoImage61 from '../../assets/resized/promo/ISP_0656.jpg';
import promoImage62 from '../../assets/resized/promo/ISP_0658.jpg';
import promoImage63 from '../../assets/resized/promo/ISP_0659.jpg';
import promoImage64 from '../../assets/resized/promo/ISP_0662.jpg';
import promoImage65 from '../../assets/resized/promo/ISP_0663.jpg';
import promoImage66 from '../../assets/resized/promo/ISP_0665.jpg';
import promoImage67 from '../../assets/resized/promo/ISP_0673.jpg';
import promoImage68 from '../../assets/resized/promo/ISP_0678.jpg';
import promoImage69 from '../../assets/resized/promo/ISP_0683.jpg';
import promoImage70 from '../../assets/resized/promo/ISP_0685.jpg';
import promoImage71 from '../../assets/resized/promo/ISP_0686.jpg';
import promoImage72 from '../../assets/resized/promo/ISP_0690.jpg';
import promoImage73 from '../../assets/resized/promo/ISP_0691.jpg';
import promoImage74 from '../../assets/resized/promo/ISP_0694.jpg';
import promoImage75 from '../../assets/resized/promo/ISP_0695.jpg';
import promoImage76 from '../../assets/resized/promo/ISP_0697.jpg';
import promoImage77 from '../../assets/resized/promo/ISP_0699.jpg';
import promoImage78 from '../../assets/resized/promo/ISP_0701.jpg';
import promoImage79 from '../../assets/resized/promo/ISP_0702.jpg';
import promoImage80 from '../../assets/resized/promo/ISP_0704.jpg';
import promoImage81 from '../../assets/resized/promo/ISP_0708.jpg';
import promoImage82 from '../../assets/resized/promo/ISP_0712.jpg';
//--------------------------------------------------------------------

//La Casa slike part 1
import lacasaImage1 from '../../assets/resized/la casa/part 1/ISP_4013.jpg';
import lacasaImage2 from '../../assets/resized/la casa/part 1/ISP_4031.jpg';
import lacasaImage3 from '../../assets/resized/la casa/part 1/ISP_4052.jpg';
import lacasaImage4 from '../../assets/resized/la casa/part 1/ISP_4133.jpg';
import lacasaImage5 from '../../assets/resized/la casa/part 1/ISP_4156.jpg';
import lacasaImage6 from '../../assets/resized/la casa/part 1/ISP_4160.jpg';
import lacasaImage7 from '../../assets/resized/la casa/part 1/ISP_4288.jpg';
import lacasaImage8 from '../../assets/resized/la casa/part 1/ISP_4295.jpg';

//La Casa slike part 2
import lacasaImage9 from '../../assets/resized/la casa/part 2/ISP_5667.jpg';
import lacasaImage10 from '../../assets/resized/la casa/part 2/ISP_5668.jpg';
import lacasaImage11 from '../../assets/resized/la casa/part 2/ISP_5673.jpg';
import lacasaImage12 from '../../assets/resized/la casa/part 2/ISP_5675.jpg';
import lacasaImage13 from '../../assets/resized/la casa/part 2/ISP_5692.jpg';
import lacasaImage14 from '../../assets/resized/la casa/part 2/ISP_5695.jpg';
import lacasaImage15 from '../../assets/resized/la casa/part 2/ISP_5702.jpg';
import lacasaImage16 from '../../assets/resized/la casa/part 2/ISP_5709.jpg';
import lacasaImage17 from '../../assets/resized/la casa/part 2/ISP_5725.jpg';
import lacasaImage18 from '../../assets/resized/la casa/part 2/ISP_5727.jpg';
import lacasaImage19 from '../../assets/resized/la casa/part 2/ISP_5743.jpg';
import lacasaImage20 from '../../assets/resized/la casa/part 2/ISP_5745.jpg';
import lacasaImage21 from '../../assets/resized/la casa/part 2/ISP_5746.jpg';
import lacasaImage22 from '../../assets/resized/la casa/part 2/ISP_5748.jpg';
import lacasaImage23 from '../../assets/resized/la casa/part 2/ISP_5777.jpg';
import lacasaImage24 from '../../assets/resized/la casa/part 2/ISP_5825.jpg';
import lacasaImage25 from '../../assets/resized/la casa/part 2/ISP_5932.jpg';
import lacasaImage26 from '../../assets/resized/la casa/part 2/ISP_6141.jpg';
import lacasaImage27 from '../../assets/resized/la casa/part 2/ISP_6142.jpg';
import lacasaImage28 from '../../assets/resized/la casa/part 2/ISP_6155.jpg';

// La Casa slike part 3
import lacasaImage29 from '../../assets/resized/la casa/part 3/ISP_006.jpg';
import lacasaImage30 from '../../assets/resized/la casa/part 3/ISP_007.jpg';
import lacasaImage31 from '../../assets/resized/la casa/part 3/ISP_008.jpg';
import lacasaImage32 from '../../assets/resized/la casa/part 3/ISP_009.jpg';
import lacasaImage33 from '../../assets/resized/la casa/part 3/ISP_010.jpg';
import lacasaImage34 from '../../assets/resized/la casa/part 3/ISP_011.jpg';
import lacasaImage35 from '../../assets/resized/la casa/part 3/ISP_012.jpg';
import lacasaImage36 from '../../assets/resized/la casa/part 3/ISP_013.jpg';
import lacasaImage37 from '../../assets/resized/la casa/part 3/ISP_014.jpg';
import lacasaImage38 from '../../assets/resized/la casa/part 3/ISP_015.jpg';
import lacasaImage39 from '../../assets/resized/la casa/part 3/ISP_016.jpg';
import lacasaImage40 from '../../assets/resized/la casa/part 3/ISP_043.jpg';
import lacasaImage41 from '../../assets/resized/la casa/part 3/ISP_068.jpg';
import lacasaImage42 from '../../assets/resized/la casa/part 3/ISP_132.jpg';
import lacasaImage43 from '../../assets/resized/la casa/part 3/ISP_148.jpg';
import lacasaImage44 from '../../assets/resized/la casa/part 3/ISP_149.jpg';

// La Casa slike part 4
import lacasaImage45 from '../../assets/resized/la casa/part 4/ISP_0103.jpg';
import lacasaImage46 from '../../assets/resized/la casa/part 4/ISP_0105.jpg';
import lacasaImage78 from '../../assets/resized/la casa/part 4/ISP_0108.jpg';
import lacasaImage47 from '../../assets/resized/la casa/part 4/ISP_0304.jpg';
import lacasaImage48 from '../../assets/resized/la casa/part 4/ISP_0315.jpg';
import lacasaImage49 from '../../assets/resized/la casa/part 4/ISP_0316.jpg';
import lacasaImage50 from '../../assets/resized/la casa/part 4/ISP_0321.jpg';
import lacasaImage51 from '../../assets/resized/la casa/part 4/ISP_0324.jpg';
import lacasaImage52 from '../../assets/resized/la casa/part 4/ISP_0327.jpg';
import lacasaImage53 from '../../assets/resized/la casa/part 4/ISP_0330.jpg';
import lacasaImage54 from '../../assets/resized/la casa/part 4/ISP_0332.jpg';
import lacasaImage55 from '../../assets/resized/la casa/part 4/ISP_0343.jpg';
import lacasaImage56 from '../../assets/resized/la casa/part 4/ISP_0353.jpg';
import lacasaImage57 from '../../assets/resized/la casa/part 4/ISP_0361.jpg';
import lacasaImage58 from '../../assets/resized/la casa/part 4/ISP_0421.jpg';
import lacasaImage59 from '../../assets/resized/la casa/part 4/ISP_0424.jpg';
import lacasaImage60 from '../../assets/resized/la casa/part 4/ISP_0455.jpg';
import lacasaImage61 from '../../assets/resized/la casa/part 4/ISP_0718.jpg';
import lacasaImage62 from '../../assets/resized/la casa/part 4/ISP_0723.jpg';
import lacasaImage63 from '../../assets/resized/la casa/part 4/ISP_0725.jpg';
import lacasaImage64 from '../../assets/resized/la casa/part 4/ISP_0821.jpg';
import lacasaImage65 from '../../assets/resized/la casa/part 4/ISP_0832.jpg';
import lacasaImage66 from '../../assets/resized/la casa/part 4/ISP_0835.jpg';
import lacasaImage67 from '../../assets/resized/la casa/part 4/ISP_0841.jpg';
import lacasaImage68 from '../../assets/resized/la casa/part 4/ISP_0842.jpg';
import lacasaImage69 from '../../assets/resized/la casa/part 4/ISP_0846.jpg';
import lacasaImage70 from '../../assets/resized/la casa/part 4/ISP_0853.jpg';
import lacasaImage71 from '../../assets/resized/la casa/part 4/ISP_0856.jpg';
import lacasaImage72 from '../../assets/resized/la casa/part 4/ISP_0858.jpg';
import lacasaImage73 from '../../assets/resized/la casa/part 4/ISP_0865.jpg';
import lacasaImage74 from '../../assets/resized/la casa/part 4/ISP_0866.jpg';
import lacasaImage75 from '../../assets/resized/la casa/part 4/ISP_0908.jpg';
import lacasaImage76 from '../../assets/resized/la casa/part 4/ISP_1277.jpg';
import lacasaImage77 from '../../assets/resized/la casa/part 4/ISP_1512.jpg';


//Wildness Fest 2025
import wildnessImage1 from '../../assets/resized/wildness 2025/IMG_0585.jpg';
import wildnessImage2 from '../../assets/resized/wildness 2025/IMG_1005.jpg';
import wildnessImage3 from '../../assets/resized/wildness 2025/IMG_4212JPG.jpg';
import wildnessImage4 from '../../assets/resized/wildness 2025/IMG_4216JPG.jpg';
import wildnessImage5 from '../../assets/resized/wildness 2025/IMG_4220JPG.jpg';
import wildnessImage6 from '../../assets/resized/wildness 2025/IMG_4222JPG.jpg';
import wildnessImage7 from '../../assets/resized/wildness 2025/IMG_4223JPG.jpg';
import wildnessImage8 from '../../assets/resized/wildness 2025/IMG_4224JPG.jpg';
import wildnessImage9 from '../../assets/resized/wildness 2025/IMG_4225JPG.jpg';
import wildnessImage10 from '../../assets/resized/wildness 2025/IMG_4226JPG.jpg';
import wildnessImage11 from '../../assets/resized/wildness 2025/IMG_4228JPG.jpg';
import wildnessImage12 from '../../assets/resized/wildness 2025/IMG_4230JPG.jpg';
import wildnessImage13 from '../../assets/resized/wildness 2025/IMG_4233JPG.jpg';
import wildnessImage14 from '../../assets/resized/wildness 2025/ISP_0019.jpg';
import wildnessImage15 from '../../assets/resized/wildness 2025/ISP_0043.jpg';
import wildnessImage16 from '../../assets/resized/wildness 2025/ISP_0079.jpg';
import wildnessImage17 from '../../assets/resized/wildness 2025/ISP_0103.jpg';
import wildnessImage18 from '../../assets/resized/wildness 2025/ISP_0105.jpg';
import wildnessImage19 from '../../assets/resized/wildness 2025/ISP_0115.jpg';
import wildnessImage20 from '../../assets/resized/wildness 2025/ISP_0141.jpg';
import wildnessImage21 from '../../assets/resized/wildness 2025/ISP_0146.jpg';
import wildnessImage22 from '../../assets/resized/wildness 2025/ISP_0679.jpg';
import wildnessImage23 from '../../assets/resized/wildness 2025/ISP_0707.jpg';

//TomorrowLE 2026
import tomorrowleImage1 from '../../assets/resized/tomorowle/ISP_0757.jpg';
import tomorrowleImage2 from '../../assets/resized/tomorowle/ISP_0764.jpg';
import tomorrowleImage3 from '../../assets/resized/tomorowle/ISP_0791.jpg';
import tomorrowleImage4 from '../../assets/resized/tomorowle/ISP_0795.jpg';
import tomorrowleImage5 from '../../assets/resized/tomorowle/ISP_0805.jpg';
import tomorrowleImage6 from '../../assets/resized/tomorowle/ISP_0807.jpg';
import tomorrowleImage7 from '../../assets/resized/tomorowle/ISP_0811.jpg';
import tomorrowleImage8 from '../../assets/resized/tomorowle/ISP_0820.jpg';
import tomorrowleImage9 from '../../assets/resized/tomorowle/ISP_0848.jpg';
import tomorrowleImage10 from '../../assets/resized/tomorowle/ISP_0864.jpg';
import tomorrowleImage11 from '../../assets/resized/tomorowle/ISP_0887.jpg';
import tomorrowleImage12 from '../../assets/resized/tomorowle/ISP_0891.jpg';
import tomorrowleImage13 from '../../assets/resized/tomorowle/ISP_0899.jpg';
import tomorrowleImage14 from '../../assets/resized/tomorowle/ISP_0901.jpg';
import tomorrowleImage15 from '../../assets/resized/tomorowle/ISP_0903.jpg';
import tomorrowleImage16 from '../../assets/resized/tomorowle/ISP_0934.jpg';
import tomorrowleImage17 from '../../assets/resized/tomorowle/ISP_09341.jpg';
import tomorrowleImage18 from '../../assets/resized/tomorowle/ISP_0938.jpg';
import tomorrowleImage19 from '../../assets/resized/tomorowle/ISP_0943.jpg';
import tomorrowleImage20 from '../../assets/resized/tomorowle/ISP_0962.jpg';
import tomorrowleImage21 from '../../assets/resized/tomorowle/ISP_0967.jpg';

const laCasa  = [
      lacasaImage45,
    lacasaImage46,
    lacasaImage78,
    lacasaImage47,
    lacasaImage48,
    lacasaImage49,
    lacasaImage50,
    lacasaImage51,
    lacasaImage52,
    lacasaImage53,
    lacasaImage54,
    lacasaImage55,
    lacasaImage56,
    lacasaImage57,
    lacasaImage58,
    lacasaImage59,
    lacasaImage60,
    lacasaImage61,
    lacasaImage62,
    lacasaImage63,
    lacasaImage64,
    lacasaImage65,
    lacasaImage66,
    lacasaImage67,
    lacasaImage68,
    lacasaImage69,
    lacasaImage70,
    lacasaImage71,
    lacasaImage72,
    lacasaImage73,
    lacasaImage74,
    lacasaImage75,
    lacasaImage76,
    lacasaImage77,
    lacasaImage1,
    lacasaImage2,
    lacasaImage3,
    lacasaImage4,
    lacasaImage5,
    lacasaImage6,
    lacasaImage7,
    lacasaImage8,
    lacasaImage9,
    lacasaImage10,
    lacasaImage11,
    lacasaImage12,
    lacasaImage13,
    lacasaImage14,
    lacasaImage15,
    lacasaImage16,
    lacasaImage17,
    lacasaImage18,
    lacasaImage19,
    lacasaImage20,
    lacasaImage21,
    lacasaImage22,
    lacasaImage23,
    lacasaImage24,
    lacasaImage25,
    lacasaImage26,
    lacasaImage27,
    lacasaImage28,
    lacasaImage29,
    lacasaImage30,
    lacasaImage31,
    lacasaImage32,
    lacasaImage33,
    lacasaImage34,
    lacasaImage35,
    lacasaImage36,
    lacasaImage37,
    lacasaImage38,
    lacasaImage39,
    lacasaImage40,
    lacasaImage41,
    lacasaImage42,
    lacasaImage43,
    lacasaImage44,
    // Part 4
  
];

  export { laCasa };

const promo = [
    promoImage60,
    promoImage61,
    promoImage62,
    promoImage63,
    promoImage64,
    promoImage65,
    promoImage66,
    promoImage67,
    promoImage68,
    promoImage69,
    promoImage70,
    promoImage71,
    promoImage72,
    promoImage73,
    promoImage74,
    promoImage75,
    promoImage76,
    promoImage77,
    promoImage78,
    promoImage79,
    promoImage80,
    promoImage81,
    promoImage82,
    promoImage37,
    promoImage38,
    promoImage39,
    promoImage40,
    promoImage41,
    promoImage42,
    promoImage43,
    promoImage44,
    promoImage45,
    promoImage46,
    promoImage47,
    promoImage48,
    promoImage49,
    promoImage50,
    promoImage51,
    promoImage52,
    promoImage53,
    promoImage54,
    promoImage55,
    promoImage56,
    promoImage57,
    promoImage58,
    promoImage59, 
    promoImage1,
    promoImage2,
    promoImage3,
    promoImage4,
    promoImage5,
    promoImage6,
    promoImage7,
    promoImage8,
    promoImage9,
    promoImage10,
    promoImage11,
    promoImage12,
    promoImage13,
    promoImage14,
    promoImage15,
    promoImage16,
    // promoImage17,
    // promoImage18,
    // promoImage19,
    // promoImage20,
    // promoImage21,
    // promoImage22,
    // promoImage23,
    // promoImage24,
    // promoImage25,
    // promoImage26,
    // promoImage27,
    // promoImage28,
    // promoImage29,
    // promoImage30,
    // promoImage31,
    // promoImage32,
    // promoImage33,
    // promoImage34,
    // promoImage35,
    // promoImage36,
  ];
  
  export { promo };

const wildFestImages = [
    wildFestImage1,
    wildFestImage2,
    wildFestImage3,
    wildFestImage4,
    wildFestImage5,
    wildFestImage6,
    wildFestImage7,
    wildFestImage8,
    // wildFestImage9,
    wildFestImage10,
    wildFestImage11,
    wildFestImage12,
    wildFestImage13,
    wildFestImage14,
    wildFestImage15,
    // wildFestImage16,
    wildFestImage17,
    wildFestImage18,
    wildFestImage19,
    wildFestImage20,
    wildFestImage21,
    wildFestImage22,
    wildFestImage23,
    wildFestImage24,
    wildFestImage25,
    wildFestImage26,
    wildFestImage27,
    wildFestImage28,
    wildFestImage29,
    wildFestImage30,
    wildFestImage31,
    wildFestImage32,
    wildFestImage33,
    wildFestImage34,
    wildFestImage35,
    wildFestImage36,
    wildFestImage37,
    wildFestImage38,
    wildFestImage39,
    wildFestImage40,
    wildFestImage41,
    wildFestImage42,
];

export { wildFestImages };

const safariImages = [

    safariImage2,

    safariImage4,

    safariImage6,

    safariImage8,
    safariImage9,
    safariImage10,
    safariImage11,
    safariImage12,
    safariImage13,
    safariImage14,
    safariImage15,
    safariImage16,
    safariImage17,
    safariImage18,
    safariImage19,
    // safariImage20,
    safariImage21,
    // safariImage22,
    // safariImage23,
    // safariImage24,
];

export { safariImages };
//--------------------------------------------------------------------


//---------------------- Wildness Fest 2025 Export ------------------------
const wildnessFest2025 = [
    wildnessImage1,
    wildnessImage2,
    wildnessImage3,
    wildnessImage4,
    wildnessImage5,
    wildnessImage6,
    wildnessImage7,
    wildnessImage8,
    wildnessImage9,
    wildnessImage10,
    wildnessImage11,
    wildnessImage12,
    wildnessImage13,
    wildnessImage14,
    wildnessImage15,
    wildnessImage16,
    wildnessImage17,
    wildnessImage18,
    wildnessImage19,
    wildnessImage20,
    wildnessImage21,
    wildnessImage22,
    wildnessImage23
];
export { wildnessFest2025 };

//---------------------- TomorrowLE 2026 Export ------------------------
const tomorrowle2026 = [
    tomorrowleImage1,
    tomorrowleImage2,
    tomorrowleImage3,
    tomorrowleImage4,
    tomorrowleImage5,
    tomorrowleImage6,
    tomorrowleImage7,
    tomorrowleImage8,
    tomorrowleImage9,
    tomorrowleImage10,
    tomorrowleImage11,
    tomorrowleImage12,
    tomorrowleImage13,
    tomorrowleImage14,
    tomorrowleImage15,
    tomorrowleImage16,
    tomorrowleImage17,
    tomorrowleImage18,
    tomorrowleImage19,
    tomorrowleImage20,
    tomorrowleImage21
];
export { tomorrowle2026 };


//---------------------- Sunset Images Export ------------------------
const sunsetImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    // image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    // image13,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
    image20,
    image21,
    image22,
    image23,
    image24,
    image25,
    image26,
    image27,
    image28,
    image29,
    image30,
];

export default sunsetImages;
